import { ShowHeader } from "@/components";
import { PaymentsTab } from "@/features/user-purchases";
import { useGetUser } from "@/queries";
import { clipboard, formatUserStatus } from "@/utils";
import { Chip, Grid, Stack, Typography } from "@mui/material";
import { FC } from "react";
import { Loading, useNotify } from "react-admin";
import { useParams } from "react-router-dom";
import { ChangeTrialPeriod } from "../change-trial-period";
import { ShortInfoPanel } from "../short-info-panel";
import { SubscriptionBlock } from "../subscription-block";
import { UserReports } from "../user-reports";
import { chipColorByStatus } from "../utils";

const UsersShow: FC = () => {
  const { id } = useParams();
  const notify = useNotify();

  const { user, isUserLoading } = useGetUser(id ?? "");

  const hasUserTrialPeriod =
    !!user?.hasInfiniteFreeTrial ||
    (user?.freeTrialEndDate
      ? new Date(user?.freeTrialEndDate).valueOf() >= new Date().valueOf()
      : false);

  if (isUserLoading) {
    return <Loading />;
  }

  return (
    <Stack direction={"column"} p={2}>
      <ShowHeader
        title="Users"
        rightAddon={
          <Stack direction="column" alignItems={"flex-end"} spacing={1}>
            <Typography
              sx={{ cursor: "pointer" }}
              onClick={() =>
                clipboard(user?.id)
                  .then(() => notify("User ID copied!", { type: "success" }))
                  .catch((error) => {
                    console.error(error.message);
                    notify(error.message, { type: "error" });
                  })
              }
            >{`ID: ${id}`}</Typography>

            {user && (
              <Chip
                size="small"
                variant="outlined"
                style={{ width: 100 }}
                color={
                  user.isDeleted ? "error" : chipColorByStatus(user.status)
                }
                label={
                  user.isDeleted ? "Deleted" : formatUserStatus(user.status)
                }
              />
            )}
          </Stack>
        }
      />

      <Stack direction={"column"} rowGap={4}>
        <ShortInfoPanel />

        <Grid container direction={"row"} spacing={4}>
          <Grid item xs={12} md={3}>
            <SubscriptionBlock />
          </Grid>
          <Grid item xs={12} md={9}>
            <Stack spacing={3}>
              {hasUserTrialPeriod && <ChangeTrialPeriod userId={user.id} />}
              <PaymentsTab />
            </Stack>
          </Grid>
        </Grid>

        <UserReports />
      </Stack>
    </Stack>
  );
};

export { UsersShow };
